
import { defineComponent, onBeforeMount, ref } from 'vue';
import moment from 'moment';
import { getLearnerEvents } from '@/utils/admin/learner_events_service';

export default defineComponent({
  name: 'LearnerEvents',
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const eventData = ref();
    const taskId = ref(props.query.learner_task_id);
    const renderReady = ref(true);
    const invokeGetLearnerEvent = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const eventRes: any = await getLearnerEvents('/v1/getSolidifyEventByTaskId', { learner_task_id: taskId.value });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const sortedArray = eventRes.sort((a: any, b: any) => moment(b.created_date).utc().unix() - moment(a.created_date).utc().unix());
      for (let index = 0; index < sortedArray.length; index += 1) {
        const element = sortedArray[index];
        element.created_date = moment(element.created_date).format('DD-MM-YYYY hh:mm:ss a');
      }
      eventData.value = sortedArray;
      // eventData.value = eventRes.sort((a: any, b: any) => a.created_date < b.created_date);
      // console.log('without Sort', eventData.value);
      // console.log('with Sort By date', eventData.value);

      renderReady.value = true;
    };
    onBeforeMount(async () => {
      await invokeGetLearnerEvent();
    });
    return { eventData, renderReady };
  },
});
